import { MetaUI } from "./MetaUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { getDefaultCategory } from "../../utils/product/getDefaultCategory";
import { useSeo } from "../../hooks/useSeo/useSeo";

export function Meta({ product }: Pick<StandardProps, "product">) {
  const { title, canonicalURL } = useSeo(product);
  const { variant } = useVariant(product);

  const defaultCategory = getDefaultCategory(product);
  const metaDescription = `Buy ${product.title} from our ${defaultCategory} range at John Lewis & Partners. Free Delivery on orders over £50.`;

  return (
    <MetaUI
      metaDescription={metaDescription}
      product={product}
      title={title}
      variant={variant}
      canonicalURL={canonicalURL}
    />
  );
}
